class JournalLiveSearch {
  constructor() {
    this.searchInput = document.querySelector('.journal-search input');
    this.searchIcon = document.querySelector('.journal-search svg');
    this.defaultContent = document.querySelector('.main-blog:not(.journal-Search) .page-width');
    this.clinicalStudies = document.querySelector('#MainContent .clinical-studies');
    this.suggestedArticles = this.defaultContent.parentNode.querySelector("#You_may_be_interested");
    this.searchResultsContainer = null;
    this.isSearchMode = false;
    this.debounceTimer = null;
    this.currentBlogHandle = this.detectBlogHandle();
    this.isInitialLoad = true;
    
    this.init();
  }
  
  init() {
    if (!this.searchInput) return;
    
    // Check for existing query parameter in URL
    this.initializeFromURL();
    
    // Add event listeners
    this.searchInput.addEventListener('input', (e) => this.handleSearchInput(e));
    this.searchInput.addEventListener('keydown', (e) => this.handleKeydown(e));
    
    // Prevent the default icon click behavior
    if (this.searchIcon) {
      this.searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.performSearch();
      });
    }
    
    // Handle browser back/forward navigation
    window.addEventListener('popstate', () => {
      this.initializeFromURL();
    });
  }
  
  handleSearchInput(e) {
    clearTimeout(this.debounceTimer);
    
    const query = e.target.value.trim();
    
    if (query === '') {
      this.showDefaultContent();
      return;
    }
    
    // Debounce search to avoid too many requests
    this.debounceTimer = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }
  
  handleKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(this.debounceTimer);
      this.performSearch(this.searchInput.value.trim());
    }
  }
  
  async performSearch(query = null) {
    if (!query) {
      query = this.searchInput.value.trim();
    }
    
    if (query === '') {
      this.showDefaultContent();
      // Remove query parameter from URL
      this.updateURL('');
      return;
    }
    
    try {
      // Update URL with query parameter
      this.updateURL(query);
      
      // Show loading state
      this.showLoadingState();
      
      // Use Shopify predictive search API
      const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article`;
      
      const response = await fetch(searchUrl);
      
      if (!response.ok) {
        throw new Error('Search request failed');
      }
      
      const data = await response.json();
      const articles = data.resources?.results?.articles || [];
      
      // Show all articles from all blogs (press and journal)
      let filteredArticles = articles;
      
      // Filter out articles without featured images
      filteredArticles = filteredArticles.filter(article => article.featured_image && article.featured_image.url);
      
      if (filteredArticles.length > 0) {
        this.showSearchResults(filteredArticles, query);
      } else {
        this.showNoResults(query);
      }
      
    } catch (error) {
      console.error('Search error:', error);
      this.showErrorState();
    }
  }
  
  showSearchResults(articles, query) {
    // Hide default content except journal-title
    if (this.defaultContent) {
      const defaultChildren = this.defaultContent.children;
      for (let child of defaultChildren) {
        if (!child.classList.contains('journal-title')) {
          child.style.display = 'none';
        }
      }
    }
    if (this.clinicalStudies) {
      this.clinicalStudies.style.display = 'none';
    }
    
    // Remove existing search results if any
    if (this.searchResultsContainer) {
      this.searchResultsContainer.remove();
    }
    
    // Create search results HTML
    const resultsHTML = this.generateSearchResultsHTML(articles, query);
    
    // Create new search results container
    this.searchResultsContainer = document.createElement('div');
    this.searchResultsContainer.className = 'search-results-content';
    this.searchResultsContainer.innerHTML = resultsHTML;
    
    // Insert search results after the default content
    if (this.defaultContent && this.defaultContent.parentNode) {
      this.defaultContent.parentNode.insertBefore(this.searchResultsContainer, this.defaultContent.nextSibling);
      
      const accordions = this.defaultContent.parentNode.querySelectorAll(".clinical-studies-3")
      if (accordions.length > 0) {
        accordions.forEach(function (btn) {
          btn.addEventListener("click", function () {
            this.classList.toggle("active");
          });
        });
      }
    }
    
    this.isSearchMode = true;
  }
  
  showDefaultContent() {
    // Show all default content children
    if (this.defaultContent) {
      const defaultChildren = this.defaultContent.children;
      for (let child of defaultChildren) {
        child.style.display = '';
      }
    }

    // Show clinical studies section if it exists
    if (this.clinicalStudies) {
      this.clinicalStudies.style.display = '';
    }

    // Hide search results container if it exists
    if (this.suggestedArticles) {
      this.suggestedArticles.style.display = 'none';
    }

    // Hide search results
    if (this.searchResultsContainer) {
      this.searchResultsContainer.style.display = 'none';
    }
    
    this.isSearchMode = false;
  }
  
  showLoadingState() {
    // Hide default content children except journal-title
    if (this.defaultContent) {
      const defaultChildren = this.defaultContent.children;
      for (let child of defaultChildren) {
        if (!child.classList.contains('journal-title')) {
          child.style.display = 'none';
        }
      }
    }
    
    // Show loading message
    if (this.searchResultsContainer) {
      this.searchResultsContainer.remove();
    }
    
    this.searchResultsContainer = document.createElement('div');
    this.searchResultsContainer.className = 'search-loading-content';
    this.searchResultsContainer.innerHTML = `
      <div class="page-width">
        <div style="padding: 60px 0; text-align: center;">
          <div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #ddd; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          <p style="margin-top: 20px; color: #666;">Searching...</p>
        </div>
      </div>
    `;
    
    if (this.defaultContent && this.defaultContent.parentNode) {
      this.defaultContent.parentNode.insertBefore(this.searchResultsContainer, this.defaultContent.nextSibling);
      if (this.suggestedArticles) {
        this.suggestedArticles.style.display = 'none';
      }
    }
    
    // Add CSS for loading spinner
    if (!document.querySelector('#loading-spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'loading-spinner-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }
  
  showNoResults(query) {
    if (this.searchResultsContainer) {
      this.searchResultsContainer.remove();
    }
    
    this.searchResultsContainer = document.createElement('div');
    this.searchResultsContainer.className = 'search-no-results-content';
    this.searchResultsContainer.innerHTML = `
      <div class="main-blog journal-Search">
        <div class="page-width">
          <div class="journal-title flex items-center gap-30 flex-column-m items-start-m m-t-80 m-t-20-m" style="display: none;">
            <h2 class="Headline-1">Journal</h2>
            <div class="journal-search b-b-1 p-b-10 flex items-center max-265 w-100">
              <input class="bg-none input-style w-100 color-t-b GTA" type="text" placeholder="Search">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_9626_11885)">
                <path d="M10.3333 10.3333L15 15M6.44444 11.8889C3.43756 11.8889 1 9.45133 1 6.44444C1 3.43756 3.43756 1 6.44444 1C9.45133 1 11.8889 3.43756 11.8889 6.44444C11.8889 9.45133 9.45133 11.8889 6.44444 11.8889Z" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_9626_11885">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div class="results">
            <span class="counts">0</span> results for your search «<span id="searchTerm">${query}</span>»
          </div>                              
        </div>
      </div>
    `;
    
    if (this.defaultContent && this.defaultContent.parentNode) {
      this.defaultContent.parentNode.insertBefore(this.searchResultsContainer, this.defaultContent.nextSibling);

      // Show suggested articles if they exist
      if (this.suggestedArticles) {
        this.suggestedArticles.style.display = '';
      }
    }
  }
  
  showErrorState() {
    if (this.searchResultsContainer) {
      this.searchResultsContainer.remove();
    }
    
    this.searchResultsContainer = document.createElement('div');
    this.searchResultsContainer.className = 'search-error-content';
    this.searchResultsContainer.innerHTML = `
      <div class="page-width">
        <div style="padding: 60px 0; text-align: center;">
          <h3>Search Error</h3>
          <p>Something went wrong. Please try again or browse our articles below.</p>
        </div>
      </div>
    `;
    
    if (this.defaultContent && this.defaultContent.parentNode) {
      this.defaultContent.parentNode.insertBefore(this.searchResultsContainer, this.defaultContent.nextSibling);
    }
    
    // Show default content as fallback
    setTimeout(() => {
      this.showDefaultContent();
    }, 3000);
  }
  
  generateSearchResultsHTML(articles, query) {
    const resultsCount = articles.length;
    
    // Separate articles by blog type
    const pressArticles = articles.filter(article => article.url.includes('/blogs/press/'));
    const journalArticles = articles.filter(article => !article.url.includes('/blogs/press/'));
    
    // Generate both press and journal sections
    let pressHTML = '';
    let journalHTML = '';
    
    if (pressArticles.length > 0) {
      pressHTML = this.generatePressSection(pressArticles);
    }
    
    if (journalArticles.length > 0) {
      journalHTML = this.generateJournalSection(journalArticles);
    }
    
    return `
      <div class="main-blog journal-Search">
        <div class="page-width">
          <div class="journal-title flex items-center gap-30 flex-column-m items-start-m m-t-80 m-t-20-m" style="display: none;">
            <h2 class="Headline-1">Journal</h2>
            <div class="journal-search b-b-1 p-b-10 flex items-center max-265 w-100">
              <input class="bg-none input-style w-100 color-t-b GTA" type="text" placeholder="Search">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_9626_11885)">
                <path d="M10.3333 10.3333L15 15M6.44444 11.8889C3.43756 11.8889 1 9.45133 1 6.44444C1 3.43756 3.43756 1 6.44444 1C9.45133 1 11.8889 3.43756 11.8889 6.44444C11.8889 9.45133 9.45133 11.8889 6.44444 11.8889Z" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_9626_11885">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div class="results">
            <span class="counts">${resultsCount}</span> results for your search «<span id="searchTerm">${query}</span>»
          </div>
          
          ${journalHTML}
          ${pressHTML}                  
        </div>
      </div>
    `;
  }
  
  generatePressSection(articles) {
    const pressItemsHTML = articles.map(article => {
      const summary = article.summary || article.excerpt || '';
      
      return `
        <div class="clinical-studies-3 flex flex-wrap b-t-1 p-t-20 p-b-40 p-relative" data-title="${article.title}">
          <div class="clinicas-btn p-absolute r-0">
            <svg class="plus" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="7" width="15" height="1" fill="#222222"/>
              <rect x="8" width="15" height="1" transform="rotate(90 8 0)" fill="#222222"/>
            </svg>
            <svg class="minus" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="7" width="15" height="1" fill="#222222"/>
            </svg>
          </div>
          <div class="left-container w-50 w-100-m p-b-20-m">
            <div class="m-0 fz-14 fz-15-m uppercase dropdoun_title inherit">Press Article</div>
          </div>
          <div class="right-container w-50 w-100-m max-590">
            <div class="m-0 Text-Big">${article.title}</div>
            <div class="text-block-studies">
              <div class="Text-1 color-gray p-t-20">
                ${summary}
              </div>
              <a class="read-article" href="${article.url}">
                Read Article
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="17" viewBox="0 0 31 17" fill="none">
                  <path d="M0 8.5H30M30 8.5L22.5 16M30 8.5L22.5 1" stroke="#847552" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      `;
    }).join('');
    
    return `
      <div class="clinical-studies press-section__results-wrapper">
        <div class="clinical-studies-2 flex flex-wrap items-center p-t-60 p-b-10">
          <div class="left-container w-50 w-100-m">
            <p class="m-0 Headline-4">Press</p>
          </div>
        </div>
        ${pressItemsHTML}
      </div>
    `;
  }
  
  generateJournalSection(articles) {
    const articlesHTML = articles.map(article => {
      const imageUrl = article.featured_image ? article.featured_image.url : '';
      const imageAlt = article.featured_image ? article.featured_image.alt || article.title : article.title;
      
      return `
        <div class="article-grid blog-item w-50-g-10 w-100-m">
          <a href="${article.url}" class="decoration-none">
            <div class="article_image_box">
              ${imageUrl ? `<img src="${imageUrl}" alt="${imageAlt}" width="460" height="300" loading="lazy">` : ''}
            </div>
            <p class="GTA fz-18 m-0 p-t-15 fz-16-m">${article.title}</p>
          </a>
        </div>
      `;
    }).join('');
    
    return `
      <div class="artical_list_box">
        <h2 class="news_heading Headline-4">News</h2>
        <div class="articles-grid flex flex-wrap gap-10 gap-row-50 gap-row-30-m">
          ${articlesHTML}
        </div>
      </div>
    `;
  }

  generateJournalSearchResultsHTML(articles, query, resultsCount) {
    const articlesHTML = articles.map(article => {
      const imageUrl = article.featured_image ? article.featured_image.url : '';
      const imageAlt = article.featured_image ? article.featured_image.alt || article.title : article.title;
      
      return `
        <div class="article-grid blog-item w-50-g-10 w-100-m">
          <a href="${article.url}" class="decoration-none">
            <div class="article_image_box">
              ${imageUrl ? `<img src="${imageUrl}" alt="${imageAlt}" width="460" height="300" loading="lazy">` : ''}
            </div>
            <p class="GTA fz-18 m-0 p-t-15 fz-16-m">${article.title}</p>
          </a>
        </div>
      `;
    }).join('');
    
    return `
      <div class="main-blog journal-Search">
        <div class="page-width">
          <div class="journal-title flex items-center gap-30 flex-column-m items-start-m m-t-80 m-t-20-m" style="display: none;">
            <h2 class="Headline-1">Journal</h2>
            <div class="journal-search b-b-1 p-b-10 flex items-center max-265 w-100">
              <input class="bg-none input-style w-100 color-t-b GTA" type="text" placeholder="Search">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_9626_11885)">
                <path d="M10.3333 10.3333L15 15M6.44444 11.8889C3.43756 11.8889 1 9.45133 1 6.44444C1 3.43756 3.43756 1 6.44444 1C9.45133 1 11.8889 3.43756 11.8889 6.44444C11.8889 9.45133 9.45133 11.8889 6.44444 11.8889Z" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_9626_11885">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div class="results">
            <span class="counts">${resultsCount}</span> results for your search «<span id="searchTerm">${query}</span>»
          </div>
          <div class="artical_list_box">
            <h2 class="news_heading Headline-4">News</h2>
            <div class="articles-grid flex flex-wrap gap-10 gap-row-50 gap-row-30-m">
              ${articlesHTML}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  generatePressSearchResultsHTML(articles, query, resultsCount) {
    const pressItemsHTML = articles.map(article => {
      const summary = article.summary || article.excerpt || '';
      
      return `
        <div class="clinical-studies-3 flex flex-wrap b-t-1 p-t-20 p-b-40 p-relative" data-title="${article.title}">
          <div class="clinicas-btn p-absolute r-0">
            <svg class="plus" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="7" width="15" height="1" fill="#222222"/>
              <rect x="8" width="15" height="1" transform="rotate(90 8 0)" fill="#222222"/>
            </svg>
            <svg class="minus" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="7" width="15" height="1" fill="#222222"/>
            </svg>
          </div>
          <div class="left-container w-50 w-100-m p-b-20-m">
            <div class="m-0 fz-14 fz-15-m uppercase dropdoun_title inherit">Press Article</div>
          </div>
          <div class="right-container w-50 w-100-m max-590">
            <div class="m-0 Text-Big">${article.title}</div>
            <div class="text-block-studies">
              <div class="Text-1 color-gray p-t-20">
                ${summary}
              </div>
              <a class="read-article" href="${article.url}">
                Read Article
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="17" viewBox="0 0 31 17" fill="none">
                  <path d="M0 8.5H30M30 8.5L22.5 16M30 8.5L22.5 1" stroke="#847552" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      `;
    }).join('');
    
    return `
      <div class="clinical-studies press-section__results-wrapper">
        <div class="page-width">
          <div class="clinical-studies-2 flex flex-wrap items-center p-t-60 p-b-10">
            <div class="left-container w-50 w-100-m">
              <p class="m-0 Headline-4">Press</p>
            </div>
          </div>
          ${pressItemsHTML}
        </div>
      </div>
    `;
  }
  
  detectBlogHandle() {
    // Try to detect which blog we're on based on the URL
    const path = window.location.pathname;
    
    if (path.includes('/blogs/news')) {
      return 'news';
    } else if (path.includes('/blogs/press')) {
      return 'press';
    } else if (path.includes('/pages/press')) {
      return 'press';
    }
    
    // Default to null (show all articles)
    return null;
  }
  
  updateURL(query) {
    const url = new URL(window.location);
    if (query) {
      url.searchParams.set('q', query);
    } else {
      url.searchParams.delete('q');
    }
    window.history.pushState({}, '', url);
  }
  
  initializeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q') || '';
    
    // Update search input to match URL
    if (this.searchInput) {
      this.searchInput.value = query;
    }
    
    // Perform search if there's a query, otherwise show default content
    if (!this.isInitialLoad) {
      if (query) {
        this.performSearch(query);
      } else {
        this.showDefaultContent();
      }
    }
    
    // Mark that initial load is complete
    this.isInitialLoad = false;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Only initialize on journal/blog pages, not on the journal-search page itself
  if (!document.querySelector('.main-blog.journal-Search')) {
    new JournalLiveSearch();
  }
});

// Backward compatibility - prevent default behavior of existing search
document.addEventListener('DOMContentLoaded', function() {
  const existingSearchIcon = document.querySelector('.journal-search svg');
  if (existingSearchIcon && !document.querySelector('.main-blog.journal-Search')) {
    // Remove existing event listeners by cloning the element
    const newIcon = existingSearchIcon.cloneNode(true);
    existingSearchIcon.parentNode.replaceChild(newIcon, existingSearchIcon);
  }
});